export default __webpack_public_path__ + "static/media/icon-chevron-left.caef9926.svg";